export const TAEKANG_SPECIFICATION_IDS = {
  HOT_FORMING: 3,
  LASER_ROUTINE: 4,
  LASER_DIMENSION: 5,
} as const;

export type TaekangInspectionLayoutType =
  | "hot-forming"
  | "laser-routine"
  | "laser-dimension";

export const getTaekangInspectionLayoutType = (
  specificationId?: number | null,
): TaekangInspectionLayoutType | null => {
  if (specificationId === TAEKANG_SPECIFICATION_IDS.HOT_FORMING) {
    return "hot-forming";
  }
  if (specificationId === TAEKANG_SPECIFICATION_IDS.LASER_ROUTINE) {
    return "laser-routine";
  }
  if (specificationId === TAEKANG_SPECIFICATION_IDS.LASER_DIMENSION) {
    return "laser-dimension";
  }
  return null;
};

export const getTaekangSpecificationIdsByEquipmentName = (
  equipmentName?: string | null,
): number[] => {
  if (!equipmentName) {
    return [];
  }

  const normalizedEquipmentName = equipmentName.toLowerCase();

  if (normalizedEquipmentName.includes("hot")) {
    return [TAEKANG_SPECIFICATION_IDS.HOT_FORMING];
  }

  if (normalizedEquipmentName.includes("laser")) {
    return [
      TAEKANG_SPECIFICATION_IDS.LASER_ROUTINE,
      TAEKANG_SPECIFICATION_IDS.LASER_DIMENSION,
    ];
  }

  return [];
};
